export default __webpack_public_path__ + "images/student/avatars/Uno-c8fbfbf6c7d69a344c65741a4f007e01.png";